import Vue from 'vue';
import vSelect from 'vue-select';

Vue.component('v-select', vSelect);

Vue.component('select-field', {
    props: ['taggable', 'name', 'options', 'initial-value', 'placeholder'],

    data () {
        return {
            value: '',
            textValue: ''
        };
    },

    computed: {
        selectOptions () {
            let options = [];

            switch (this.name) {
                case 'contact_industry':
                    for (let item in this.options) {
                        options.push(this.options[item].value);
                    }

                    return options;
                case 'country':
                    for (let item in this.options) {
                        options.push(this.options[item].name);
                    }

                    return options;
                case 'referrer':
                    for (let item in this.options) {
                        options.push(this.options[item].contact_name);
                    }

                    return options;
                case 'region':
                    for (let item in this.options) {
                        options.push(this.options[item].name);
                    }

                    return options;
                default:
                    return this.options;
            }
        }
    },

    mounted() {
        this.handleInitialValue();
    },

    watch: {
        initialValue () {
            this.handleInitialValue();
        }
    },

    methods: {
        handleInitialValue () {
            if (this.initialValue !== undefined && this.initialValue !== null && this.initialValue.length != 0) {
                if (this.options[0] !== undefined && this.options[0].value !== undefined) {
                    let option = Object.values(this.options).filter((o) => {
                        return o.value === this.initialValue;
                    });

                    this.value = option[0].value;
                    this.textValue =  option[0].value;
                } else {
                    this.value = this.initialValue;
                    this.textValue = this.initialValue;
                }
            }
        },

        handleInput () {
            this.$emit('change', this.value);

            if (this.value != null && this.value.value !== undefined) {
                this.textValue = this.value.value;
            } else {
                this.textValue = this.value;
            }
        }
    },

    template: `
        <div>
            <v-select :taggable="taggable" :options="selectOptions" v-model="value" style="width: 100%;" @input="handleInput" :placeholder="placeholder"></v-select>
            <input type="hidden" v-model="textValue" :name="name">
        </div>
    `
});
